import { mapActions } from 'vuex'

const Dialog = {
  methods: {
    ...mapActions({
      _openDialog: 'dialogscreen/openDialog',
      g_closeDialog: 'dialogscreen/closeDialog',
      g_resetDialog: 'dialogscreen/resetDialog'
    }),
    g_openDialog (title, message, buttonCommit = '', buttonCancel = '', isModal = false, fnEvent = null) {
      this._openDialog({
        title: title,
        message: message,
        buttonCommit: buttonCommit,
        buttonCancel: buttonCancel,
        modal: isModal,
        fnEvent: fnEvent
      })
    }
  }
}
export default Dialog
